import { z } from 'zod';

/**
 * Zod schema for the PATCH /suppliers/{de_id} request payload
 * (SupplierRelationshipPatch).
 *
 * All fields are optional — only included fields are patched.
 */
export const zodUpdateSupplierRelationshipPayloadSchema = z.object({
  customerNumbers: z.array(z.string()).nullish(),
  responsiblePersonId: z
    .union([z.uuid(), z.literal('')])
    .nullish()
    .transform((value) => (value === '' ? null : value)),
  revenue: z.union([z.number(), z.string()]).nullish(),
  revenueCurrency: z.string().nullish(),
  supplierNumber: z.string().nullish(),
});
